import React, { useState } from 'react'
import { AiOutlineHome, AiOutlineUser } from 'react-icons/ai'
import { BiBookBookmark } from 'react-icons/bi'
import { MdContacts } from 'react-icons/md'
import { RiServiceLine } from 'react-icons/ri'
import './Nav.css'


const Nav = () => {
  const[activeNav,setActiveNav] = useState("#")
  return (
    <nav>
      <a href="#header" onClick={()=>setActiveNav('#')}  className={activeNav ==='#' ? 'active': ''} ><AiOutlineHome/></a>
      <a href="#about" onClick={()=>setActiveNav('#about')} className={activeNav ==='#about' ? 'active': ''}  ><AiOutlineUser/></a>
      <a href="#experience" onClick={()=>setActiveNav('#experience')}  className={activeNav ==='#experience' ? 'active': ''} ><BiBookBookmark/></a>
      <a href="#services" onClick={()=>setActiveNav('#services')}  className={activeNav ==='#services' ? 'active': ''}><RiServiceLine/></a>
      <a href="#contact"onClick={()=>setActiveNav('#contact')}  className={activeNav ==='#contact' ? 'active': ''} ><MdContacts/></a>
    </nav>

    // onClick={()=>setActiveNav('#')}  className={activeNav =='#' ? 'active': ''}
    // this will help nav to work on its own
  )

}

export default Nav